module.exports = __webpack_public_path__ + "img/description3.526c4064.jpg";